module.exports = __webpack_public_path__ + "img/logo12@2x.07b74e88.png";